<mat-form-field>
  <mat-label>{{ label }}</mat-label>

  <input type="text" matInput [formControl]="control" [required]="isRequired(control)" />

  @if (control.invalid) {
    <mat-error>{{ control.errors | json }}</mat-error>
  }
</mat-form-field>
